<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '1%', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetIpsecTunnelCount',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 3,
        self: this,
        title: 'widgetIpsecTunnelCount',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        widgetData: [],
        xAxisRawData: {
          type: 'time',
          axisLine: {onZero: true},
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: [
          {
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: value => this.kmgtConverter(Math.abs(value))
            }
          }
        ]
      }
    },
    computed: {
      series () {
        return [
          { id: 'ipsecTunnelCount', type: 'bar', name: this.$t('dash.widgetIpsecTunnelCount_title_normalCount'), barWidth: '100%' },
          { id: 'ipsecTotalCount', type: 'line', name: this.$t('dash.widgetIpsecTunnelCount_title_totalCount'), itemStyle: {color: '#FF0000'} }
        ]
      },
      xAxis: {
        get () { return this.xAxisRawData },
        set (options) { this.xAxisRawData = options }
      },
      yAxis: {
        get () {
          return this.yAxisRawData
        },
        set (options) {
          this.yAxisRawData = options
        }
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const cnt = Math.abs(params[i].value[1])
              resFormat += `${params[i].marker}${params[i].seriesName} : <b>${this.separateByComma(cnt)}${this.restData.unit_time}</b><br>`
            }
            return resFormat
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        const contentsOptions = {
          widgetType: 'ipsec_vpn_tunnel_trend'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Series 데이터 구성
        // if (code === 'ok' && result.result.length > 0) {
        if (code === 'ok' && _.get(result, ['result', 'length'], 0) > 0) {
          this.restData = result
          const tunnelCount = []
          const tunnelTotalCount = []
          let maxVal = 0

          for (const tunnelData of this.restData.result || []) {
            maxVal = Math.max(maxVal, tunnelData.normal_tunnel_cnt)
            maxVal = Math.max(maxVal, tunnelData.tot_tunnel_cnt)

            tunnelCount.push([tunnelData.time, tunnelData.normal_tunnel_cnt])
            tunnelTotalCount.push([tunnelData.time, tunnelData.tot_tunnel_cnt])
          }

          this.yAxis[0].max = _.ceil(maxVal, -Math.abs(maxVal.toString().length) + 3) || 1

          this.widgetData = [tunnelCount, tunnelTotalCount]
        } else {
          // TAMS - All update 기준
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
